// Logical game viewport. Phaser scales this to the window.
export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 960;

// Header bar shared across gameplay scenes.
export const HEADER_HEIGHT = 80;

// Starter oven capacity. Phase 3 equipment upgrades raise this.
export const OVEN_RACKS = 2;

// ── Time model ───────────────────────────────────────────────────────────────
// All in-fiction time is "game seconds". 1 real second = TIME_RATE_MULTIPLIER
// game seconds; the day clock, oven bakes, and kitchen timers all tick in
// the same units so the player reads one time scale everywhere.
export const TIME_RATE_MULTIPLIER = 8; // tester feedback: 4× felt slow

// Pre-open: kitchen + oven prep. 7200 game-sec = 2 game-hours ≈ 15 real-min at 8×.
export const PRE_OPEN_GAME_SECONDS = 7200;

// Open: front-of-house service. 14400 game-sec = 4 game-hours ≈ 30 real-min at 8×.
export const OPEN_GAME_SECONDS = 14400;

export { COLORS } from './ui/theme';
